/* eslint-disable max-depth */
import { useState, useEffect } from 'react';
import { Auth } from '@aws-amplify/auth';

export default function useAuthenticationStatus(): [boolean, boolean] {
  // Set default to true until we can check if they are authenticated
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        console.log('🔍 Checking authentication status...');
        console.log('🔍 Environment:', process.env.REACT_APP_NODE_ENV);
        console.log(
          '🔍 User Pool ID:',
          process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
        );
        console.log(
          '🔍 Web Client ID:',
          process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
        );

        const session = await Auth.currentSession();
        console.log(
          '🔍 Session result:',
          session ? 'Session found' : 'No session',
        );

        if (session) {
          const accessTokenExpire = session.getAccessToken().getExpiration();
          const refreshToken = session.getRefreshToken();
          const currentTimeSeconds = Math.round(+new Date() / 1000);
          console.log('🔍 Token expiration:', accessTokenExpire);
          console.log('🔍 Current time:', currentTimeSeconds);
          console.log(
            '🔍 Token expired:',
            accessTokenExpire < currentTimeSeconds,
          );

          // if token has expired refresh it and set authed to true
          if (accessTokenExpire < currentTimeSeconds) {
            console.log('🔍 Token expired, attempting refresh...');
            const authenticatedUser = await Auth.currentAuthenticatedUser();
            if (authenticatedUser) {
              console.log('🔍 User found, refreshing session...');
              await authenticatedUser.refreshSession(refreshToken);
              setIsAuthenticated(true);
              setLoading(false);
              console.log('🔍 Session refreshed successfully');
              return;
            }
            // if this occurs then something weird has happened and then lets just set them to not authenticated
            console.log('🔍 User not found after token expiration');
            setIsAuthenticated(false);
            setLoading(false);
            return;
          }
          // tokens are not expired
          console.log('🔍 Token not expired, user authenticated');
          setIsAuthenticated(true);
          setLoading(false);
          return;
        }
        console.log('🔍 No session found, user not authenticated');
        setIsAuthenticated(false);
        setLoading(false);
      } catch (e) {
        // if at any point this fails then we are not authenticated
        console.error('🔍 Authentication error:', e);
        setIsAuthenticated(false);
        setLoading(false);
      }
    })();
  }, []);

  return [isAuthenticated, loading];
}
